import { useQuery } from '@tanstack/react-query';
import { staleTime } from 'corso-admin-ui';
import api from '~/api';

/** The shop currencies an organization's stores use; its dashboards read one at a time. */
export function useOrganizationCurrencies(organizationId: number | undefined) {
  return useQuery({
    queryKey: ['analytics', 'currencies', organizationId],
    queryFn: () => api.organization(`${organizationId}`).analytics.currencies(),
    select: ({ currencies }) => currencies,
    enabled: organizationId !== undefined,
    staleTime,
  });
}
